<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="7.5" stroke="black" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.22 6.82894C9.36 6.6918 9.5 6.33522 9.5 6.14322C9.5 5.7795 9.35952 5.43067 9.10948 5.17348C8.85943 4.91628 8.52029 4.77179 8.16667 4.77179C7.81304 4.77179 7.47391 4.91628 7.22386 5.17348C6.97381 5.43067 6.83333 5.7795 6.83333 6.14322H5.5C5.5 5.41577 5.78095 4.71812 6.28105 4.20373C6.78115 3.68934 7.45942 3.40037 8.16667 3.40037C8.87391 3.40037 9.55219 3.68934 10.0523 4.20373C10.5524 4.71812 10.8333 5.41577 10.8333 6.14322C10.8333 6.70551 10.5467 7.40494 10.1667 7.80265L9.11333 8.88608C8.97333 9.02322 8.83333 9.37294 8.83333 9.57179V10.2575H7.5V9.57179C7.5 9.00951 7.78667 8.31008 8.16667 7.91237L9.22 6.82894ZM7.5 13.0004V11.6289H8.83333V13.0004H7.5Z" fill="black" />
  </svg>
</template>

<script>
  export default {
    name: "HelpIcon"
  }
</script>